import { call, CallEffect, PutEffect, SelectEffect, select } from "redux-saga/effects";
import { AxiosResponse } from "axios";
import { automaticApi } from "@/settings/api";
import { ReducersTypes } from "@/redux/reducers/Models";
import { Action } from "redux-saga";
import environment from "@/settings/environment";
import { clearString } from "@/utils/functions";

export interface Fetch {
  password: string;
  newPassword: string;
  callback: (success: boolean, errorMessage?: string) => void;
}

export interface ChangePasswordAuthAction {
  type: string;
  payload: Fetch;
}

const uri = `/login-app/${environment.api?.loginVersion ?? "v4"}/alterarsenhaatual`;

const getCustomerReducer = (state: ReducersTypes) => state.customerReducer;

export default function* changePasswordAuth({
  payload,
}: ChangePasswordAuthAction): Generator<
  CallEffect<unknown> | PutEffect<Action> | SelectEffect,
  void,
  AxiosResponse
> {
  try {
    // @ts-expect-error
    const customer: ReducersTypes["customerReducer"] =
      yield select(getCustomerReducer);

    const response = yield call(automaticApi.post, uri, {
      cpf: clearString(customer?.username!),
      senhaAtual: payload.password,
      senhaNova: payload.newPassword,
    });

    if (response?.data?.status?.codigoRetorno === 0) {
      yield call(payload.callback, true);
    } else {
      yield call(payload.callback, false);
    }
  } catch (error) {
    yield call(payload.callback, false);
  }
}
